// 그래픽 콘솔(D-1)의 순수 규칙: 게스트로 보낼 키의 keysym 과, 텍스트를 키 입력으로 바꾸는 절차.
// @novnc/novnc 의 exports 는 core/rfb.js 하나라 keysym 표를 가져오지 못한다 — 값은 X11 의 것이고 바뀌지 않는다.

export const XK_TAB = 0xff09
export const XK_RETURN = 0xff0d
export const XK_ESCAPE = 0xff1b
export const XK_CONTROL_L = 0xffe3
export const XK_ALT_L = 0xffe9
export const XK_SUPER_L = 0xffeb

export type KeySender = { sendKey(keysym: number, code: string | null, down?: boolean): void }

/**
 * 텍스트를 키 입력으로 타이핑한다. QEMU VNC 는 게스트 안 vdagent 없이는 클립보드가 없다.
 * ASCII 는 코드 포인트가 곧 keysym, 줄바꿈은 Return, 탭은 Tab, 그 밖의 유니코드는 X11 규약(0x01000000 + 코드 포인트).
 * 제어 문자는 보낼 수 없어 건너뛴다. 보낸 글자 수와 건너뛴 글자 수를 돌려준다.
 */
export function typeText(rfb: KeySender, text: string): { sent: number; skipped: number } {
  let sent = 0
  let skipped = 0
  for (const ch of text) {
    const cp = ch.codePointAt(0) ?? 0
    let keysym: number | null = null
    if (ch === '\n') keysym = XK_RETURN
    else if (ch === '\t') keysym = XK_TAB
    else if (ch === '\r') continue
    else if (cp >= 0x20 && cp <= 0x7e) keysym = cp
    else if (cp >= 0xa0) keysym = 0x01000000 + cp
    if (keysym === null) {
      skipped++
      continue
    }
    rfb.sendKey(keysym, null)
    sent++
  }
  return { sent, skipped }
}
